import { useReducer, useEffect, useState } from 'react'
import { useRouter } from 'next/router';

const INPUT_CHANGE = 'INPUT_CHANGE';
const INPUT_FOCUS = 'INPUT_FOCUS';
const INPUT_RESET = 'INPUT_RESET';

const inputReducer = (state, action) => {
    switch (action.type) {
        case INPUT_CHANGE:
            return {
                ...state,
                value: action.value,
                isValid: action.isValid
            }
        case INPUT_FOCUS:
            return {
                ...state,
                touched: true
            }
        case INPUT_RESET:
            return {
                value: '',
                isValid: false,
                touched: false,
            }
        default:
            return state;
    }
};

const Input = (props) => {

    const [inputState, dispatchInputState] = useReducer(inputReducer, {
        value: props.initvalue ? props.initialValue : '',
        isValid: props.initialValid ? props.initialValid : false,
        touched: false,
    })

    const router = useRouter();
    let language =  router.locale === "tr" ?  "Turkish" : "English";


    const [error, setError] = useState('');

    const { onChangeInput, name, completed } = props;
    // const { touched } = inputState;

    useEffect(() => {
        onChangeInput(name, inputState.value, inputState.isValid);
    }, [name, inputState.value, inputState.isValid, onChangeInput]);


    useEffect(() => {
        dispatchInputState({
            type: INPUT_RESET
        })
    }, [completed])

    const onChangeHandler = (event) => {

        const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        const nameRegex = /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,24}$/;
        let isValid = true;

        if (props.email && !emailRegex.test(event.target.value.toLowerCase())) {
            isValid = false;
            setError(language === "Turkish" ? "E-posta adresini doğru giriniz." : "You must enter correct email");
        }
        if ((props.name === "name" || props.name === "surName") &&
            !nameRegex.test(event.target.value.trim())) {
            isValid = false;
            setError(language === "Turkish" ? "Alan minimum üç karakter olmalı ve özel karakter ile rakam içermemelidir.": "You must enter at least minumum 3 character");
        }

        if (props.min !== null && +event.target.value.trim().length < props.min) {
            isValid = false;
            setError(language === "Turkish" ? `Alan minimum ${props.min} karakter içermelidir.` : `You must enter at least minumum ${props.min} character`);
        }
  
        if (props.required && event.target.value.trim().length === 0) {
            isValid = false;
            setError(language === "Turkish" ? "Bu alan boş bırakılamaz.": "This field cannot be left blank");
        }

        dispatchInputState({
            type: INPUT_CHANGE,
            value: event.target.value,
            isValid: isValid
        })
    }

    const lostFocusHandler = () => {
        dispatchInputState({
            type: INPUT_FOCUS
        })
    }

    return (
        <div className="col" >
            {props.type !== "textarea" ?
                <div className="form-label-group" >
                    <input
                        className="form-control"
                        {...props}
                        value={inputState.value}
                        onChange={onChangeHandler}
                        onFocus={lostFocusHandler}
                        id={props.name} 
                        autoFocus={false}
                        />
                    <label htmlFor={props.name} className="mb-0">{props.placeholder}</label>
                    {!inputState.isValid && inputState.touched && props.press === "true" &&
                <div className="invalid-feedback" style={{ display: "block" }}> {error} </div>}
                </div>
                :
                <div className="form-label-group" style={{height:"100%"}}>
                    <textarea
                        id={props.name}
                        rows="7"
                        autoFocus={false}
                        className="form-control"
                        {...props}
                        value={inputState.value}
                        onChange={onChangeHandler}
                        onFocus={lostFocusHandler}
                        style={{height:"100%"}}
                    >
                    </textarea>
                    <label htmlFor={props.name} className="mb-0">{props.placeholder}</label>
                    {!inputState.isValid && inputState.touched && props.press === "true" &&
                <div className="invalid-feedback" style={{ display: "block" }}> {error} </div>}
                </div>
            }
            
        </div>

    )
}




export default Input;